import { createFetcher, ErrorPolicy } from '@udemy/graphql';

/**
 * Determines the GraphQL endpoint URL based on the environment.
 * In Storybook, uses relative URL which goes through the middleware proxy to avoid CORS issues.
 * The middleware proxies GraphQL requests to the real API.
 * In production, uses relative URL which will be handled by the server.
 */
function getGraphQLUrl() {
  // Always use relative URL - the Storybook middleware will proxy it to the real API
  // This avoids CORS issues when making requests from localhost:6006
  return '/api/2024-01/graphql/';
}

/**
 * Provides default headers for GraphQL requests.
 * The X-Requested-With header is required by the Udemy API even for public queries.
 */
function getHeaders() {
  return {
    'X-Requested-With': 'XMLHttpRequest'
  };
}
export const fetcher = createFetcher({
  errorPolicy: ErrorPolicy.ALLOW_PARTIAL,
  getUrl: getGraphQLUrl,
  getHeaders
});
//# sourceMappingURL=fetcher.js.map